<template>
  <v-dialog
    v-model="dialog"
    width="1300"
    :fullscreen="$vuetify.breakpoint.mobile"
    scrollable
  >
    <search-detail :search="search"></search-detail>
  </v-dialog>
</template>

<script>
import SearchDetail from "@/components/searches/Detail";

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    search: {
      type: Object,
      required: true
    }
  },

  components: {
    SearchDetail
  }
};
</script>
